import React from 'react';
import './InvitedScreen.css';
import checkIcon from '../assets/Check.svg';


const InvitedScreen = ({business_info, customer_info, setShowModal}) => {
	// Determine background image based on business_id
	const backgroundImage = customer_info.business_id === 75
	  ? 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.9)), url("https://i.ibb.co/k2vKnB51/8-F4-A9424-1.jpg")'
	  : customer_info.business_id === 88
    ? 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.9)), url("https://i.ibb.co/chWqyYJV/Cafe-C-Interface-Waitwhiz-ai.jpg")'
	  : 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.9)), url("https://i.ibb.co/nMdYspGB/waitwhiz-background-image.jpg")';
  
	return (
	  <div className="screen-root" style={{ background: backgroundImage, color: '#fff' }}>
		<div className="frame-parent">
		  <div className="waitwhiz-logo-pure-white-backg-parent-waiting">
			<img className="brand-logo" alt="" src={business_info.business_metadata.logo_url} />
		  </div>
		  <div className="frame-group">
			<div className="hi-user">
			  <b className="hi-user-text">Hi {customer_info.customer_name},</b>
			  <b className="hi-user-text">Your turn is up! Please visit the reception.</b>
			</div>
			<div className="ellipse-parent" style={{backgroundColor: 'transparent'}}>
	          <div className="frame-child"></div>
	          <img className="check-icon" alt="" src={checkIcon} />
	        </div>
			<div className="for-menu-click-here-parent">
			  <div className="hi-user-text">
				<a
				  className="click-here"
				  href={business_info.business_metadata.menu_url}
				  target="_blank"
				  rel="noopener noreferrer"
				  style={{ marginRight: 8, display: 'inline-block', verticalAlign: 'middle' }}
				>
				  Tap Here
				</a>
				<span style={{ display: 'inline-block', verticalAlign: 'middle' }}>
				  <p>to See Our Menu</p>
				</span>
			  </div>
			</div>
		  </div>
		  <div className="for-menu-click-here-parent">
			  <p className="hi-user-text">
				Thanks for choosing us.
				<br />
				<span style={{ display: 'inline-block', marginTop: '4px' }}>
				  We look forward to hosting you! 
				</span>
			  </p>
			</div>
		</div>
		{/* Business Ad Creative */}
		<div className="business-ad-creative">
		  {business_info.business_metadata.ad_creative && (
			<img
			  src={business_info.business_metadata.ad_creative}
			  alt="Business Ad Creative"
			  className="ad-creative-img"
			/>
		  )}
		</div>
		<div className="cancle-queue-button">
		  <div className="star" />
		  <div
			className="cancel-queue"
			onClick={() => setShowModal(true)}
		  >
			Cancel Queue
		  </div>
		  <div className="star" />
		</div>
	  </div>
	);
  };

export default InvitedScreen;
